import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white border border-primary-200 rounded-xl shadow-soft p-4 overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-primary-800 mb-3" }, " Community ", -1)
const _hoisted_3 = { class: "space-y-2 overflow-hidden" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-accent-100 rounded-lg flex items-center justify-center group-hover:bg-accent-200 transition-colors" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4 text-accent-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
    })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-primary-700" }, "Proposals", -1)
const _hoisted_7 = { class: "text-xs text-primary-500" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-primary-300 group-hover:text-primary-500 transition-colors",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_9 = { class: "flex items-center gap-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition-colors" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4 text-blue-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
    })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-primary-700" }, "Votes", -1)
const _hoisted_12 = { class: "text-xs text-primary-500" }
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = {
  key: 0,
  class: "px-2 py-0.5 text-xs font-medium bg-blue-100 text-blue-700 rounded-full"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-primary-300 group-hover:text-primary-500 transition-colors",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center group-hover:bg-amber-200 transition-colors" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "w-4 h-4 text-amber-600",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-primary-700" }, " Neighborhood Dogs "),
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-primary-500" }, "Meet the pups!")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-primary-300 group-hover:text-primary-500 transition-colors",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)


export default /*#__PURE__*/_defineComponent({
  props: {
    proposalCount: null,
    voteCount: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/proposals",
        class: "flex items-center justify-between p-3 rounded-lg hover:bg-primary-50 transition-colors group"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", null, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(__props.proposalCount) + " active", 1)
            ])
          ]),
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/votes",
        class: "flex items-center justify-between p-3 rounded-lg hover:bg-primary-50 transition-colors group"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("p", _hoisted_12, _toDisplayString(__props.voteCount > 0 ? `${__props.voteCount} open` : "None open"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (__props.voteCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Vote now "))
              : _createCommentVNode("", true),
            _hoisted_15
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/doggos",
        class: "flex items-center justify-between p-3 rounded-lg hover:bg-primary-50 transition-colors group"
      }, {
        default: _withCtx(() => [
          _hoisted_16,
          _hoisted_17
        ]),
        _: 1
      })
    ])
  ]))
}
}

})